import axiosCustom from "@/utils/axiosCustom";
import IProduct from "@/models/protocols/IProduct";

import store from "@/store/index";

export default class ProductService {
  /**
   * Gets all products from remote system.
   * @returns
   */
  static async all(): Promise<IProduct[]> {
    let products = (store.state as any).Root.products;

    if (products.length == 0) {
      const { data } = await axiosCustom.get(
        "/rest/V1/WAG/products/progressive"
      );
      // eslint-disable-next-line no-console
      console.log(data.data);
      store.commit("Root/SET_PRODUCTS", Object.values(data));
      products = (store.state as any).Root.products;
    }

    return products;
  }
}
